var ge = Object.defineProperty;
var ve = (e, t, r) => t in e ? ge(e, t, { enumerable: !0, configurable: !0, writable: !0, value: r }) : e[t] = r;
var T = (e, t, r) => (ve(e, typeof t != "symbol" ? t + "" : t, r), r);
import { jsx as C, jsxs as M } from "react/jsx-runtime";
import { createContext as se, useRef as U, useState as N, useEffect as $, forwardRef as W, createElement as F, Suspense as we } from "react";
import * as be from "@tanstack/react-query";
import { useSuspenseQuery as Ce, dehydrate as _e, hydrate as Ee, QueryClientProvider as xe, QueryClient as ke } from "@tanstack/react-query";
import { I18nextProvider as Te, useTranslation as ie } from "react-i18next";
import "i18next";
const Ae = ({ children: e, i18nInstance: t }) => /* @__PURE__ */ C(Te, { i18n: t, children: e }), Se = (e = "label") => {
  const t = Array.isArray(e) ? e : [e];
  return ie(t);
};
var k = typeof globalThis < "u" ? globalThis : typeof window < "u" ? window : typeof global < "u" ? global : typeof self < "u" ? self : {}, Oe = typeof k == "object" && k && k.Object === Object && k, Le = typeof self == "object" && self && self.Object === Object && self;
Oe || Le || Function("return this")();
/*! js-cookie v3.0.5 | MIT */
function I(e) {
  for (var t = 1; t < arguments.length; t++) {
    var r = arguments[t];
    for (var n in r)
      e[n] = r[n];
  }
  return e;
}
var Re = {
  read: function(e) {
    return e[0] === '"' && (e = e.slice(1, -1)), e.replace(/(%[\dA-F]{2})+/gi, decodeURIComponent);
  },
  write: function(e) {
    return encodeURIComponent(e).replace(
      /%(2[346BF]|3[AC-F]|40|5[BDE]|60|7[BCD])/g,
      decodeURIComponent
    );
  }
};
function q(e, t) {
  function r(o, i, s) {
    if (!(typeof document > "u")) {
      s = I({}, t, s), typeof s.expires == "number" && (s.expires = new Date(Date.now() + s.expires * 864e5)), s.expires && (s.expires = s.expires.toUTCString()), o = encodeURIComponent(o).replace(/%(2[346B]|5E|60|7C)/g, decodeURIComponent).replace(/[()]/g, escape);
      var a = "";
      for (var c in s)
        s[c] && (a += "; " + c, s[c] !== !0 && (a += "=" + s[c].split(";")[0]));
      return document.cookie = o + "=" + e.write(i, o) + a;
    }
  }
  function n(o) {
    if (!(typeof document > "u" || arguments.length && !o)) {
      for (var i = document.cookie ? document.cookie.split("; ") : [], s = {}, a = 0; a < i.length; a++) {
        var c = i[a].split("="), u = c.slice(1).join("=");
        try {
          var f = decodeURIComponent(c[0]);
          if (s[f] = e.read(u, f), o === f)
            break;
        } catch {
        }
      }
      return o ? s[o] : s;
    }
  }
  return Object.create(
    {
      set: r,
      get: n,
      remove: function(o, i) {
        r(
          o,
          "",
          I({}, i, {
            expires: -1
          })
        );
      },
      withAttributes: function(o) {
        return q(this.converter, I({}, this.attributes, o));
      },
      withConverter: function(o) {
        return q(I({}, this.converter, o), this.attributes);
      }
    },
    {
      attributes: { value: Object.freeze(t) },
      converter: { value: Object.freeze(e) }
    }
  );
}
q(Re, { path: "/" });
se({});
function V(e) {
  return e.toLowerCase().split(" ").map(function(t) {
    return t.replace(t[0], t[0].toUpperCase());
  }).join(" ");
}
se({
  pageUrl: ""
});
function Pe({
  apiKey: e,
  clickoutOrigin: t,
  clickoutServiceUrl: r,
  deviceType: n,
  fullPageUrl: o,
  gtmId: i,
  offers: s,
  pageUrl: a,
  recommendedMarketId: c,
  shouldUseClickoutService: u
}) {
  return !u || !r ? s ?? [] : s != null && s.length ? s.map((f, y) => {
    const h = {
      apiKey: e,
      clickoutOrigin: t,
      containerId: i,
      deviceType: n,
      fullPageUrl: o,
      offerId: String(f == null ? void 0 : f.id),
      offerPosition: String(y),
      pageUrl: a,
      recommendedMarketId: c
    }, d = new URL(r), g = d.searchParams;
    for (const [p, m] of Object.entries(h))
      m != null && g.set(p, m);
    return d.search = g.toString(), {
      ...f,
      clickOutUrl: d.toString()
    };
  }) : [];
}
function z() {
  return /* @__PURE__ */ C("svg", { fill: "none", height: "11", viewBox: "0 0 7 11", width: "7", xmlns: "http://www.w3.org/2000/svg", children: /* @__PURE__ */ C("path", { d: "M1.26717 1.00004L5.53433 5.24268L1.26717 9.48532", id: "Rectangle", stroke: "currentColor", strokeWidth: "2" }) });
}
const je = (e) => De[e] || void 0, X = 19, Ie = "wrapper_wumqgj", Me = "container_cc8cxyz", De = {
  autohide: "autohide_axz1gvw",
  default: "default_dsywwer"
}, Ue = (e) => `${Me} ${je(e)}`, Ne = () => {
  const e = U(null), t = U(null), [r, n] = N(!1), [o, i] = N(!1);
  return $(() => {
    const s = e.current;
    if (!s)
      return;
    const a = () => {
      n(s.scrollLeft > 0), i(s.scrollLeft + s.clientWidth < s.scrollWidth - 1);
    };
    a(), s.addEventListener("scroll", a, { passive: !0 });
    const c = new ResizeObserver(a);
    return c.observe(s), () => {
      s.removeEventListener("scroll", a), c.disconnect();
    };
  }, []), $(() => {
    const s = t.current;
    if (!s)
      return;
    const a = () => {
      const c = s.getBoundingClientRect(), u = Math.max(0, Math.min(c.left, X)), f = Math.max(0, Math.min(window.innerWidth - c.right, X));
      s.style.setProperty("--arrow-left", `-${u}px`), s.style.setProperty("--arrow-right", `-${f}px`);
    };
    return a(), window.addEventListener("resize", a), () => window.removeEventListener("resize", a);
  }, []), { canScrollLeft: r, canScrollRight: o, containerRef: e, wrapperRef: t };
}, $e = (e, t) => Number(window.getComputedStyle(e, null).getPropertyValue(t).replace("px", "")), Fe = ({
  children: e,
  uncappedOfferDisplay: t,
  variant: r = "default"
}) => {
  const n = Ue(r), { canScrollLeft: o, canScrollRight: i, containerRef: s, wrapperRef: a } = Ne(), c = (u) => {
    if (s.current) {
      const f = s.current, y = $e(f, "column-gap"), d = f.children[0].offsetWidth + y;
      u ? f.scrollLeft += d : f.scrollLeft -= d;
    }
  };
  return /* @__PURE__ */ M("div", { className: Ie, ref: a, children: [
    /* @__PURE__ */ C("div", { className: n, "data-uncapped": t || void 0, ref: s, children: e }),
    /* @__PURE__ */ C(
      "button",
      {
        "aria-label": "Scroll Left",
        onClick: () => c(),
        style: { display: o ? "flex" : "none" },
        children: /* @__PURE__ */ C(z, {})
      }
    ),
    /* @__PURE__ */ C(
      "button",
      {
        "aria-label": "Scroll Right",
        onClick: () => c(!0),
        style: { display: i ? "flex" : "none" },
        children: /* @__PURE__ */ C(z, {})
      }
    )
  ] });
}, qe = (e) => {
  if (!e)
    return "";
  const t = new URL(e);
  return t.searchParams.append("fm", "webp"), t.searchParams.append("w", "190"), t.toString();
};
function ze(e) {
  var t = /* @__PURE__ */ Object.create(null);
  return function(r) {
    return t[r] === void 0 && (t[r] = e(r)), t[r];
  };
}
var He = /^((children|dangerouslySetInnerHTML|key|ref|autoFocus|defaultValue|defaultChecked|innerHTML|suppressContentEditableWarning|suppressHydrationWarning|valueLink|abbr|accept|acceptCharset|accessKey|action|allow|allowUserMedia|allowPaymentRequest|allowFullScreen|allowTransparency|alt|async|autoComplete|autoPlay|capture|cellPadding|cellSpacing|challenge|charSet|checked|cite|classID|className|cols|colSpan|content|contentEditable|contextMenu|controls|controlsList|coords|crossOrigin|data|dateTime|decoding|default|defer|dir|disabled|disablePictureInPicture|disableRemotePlayback|download|draggable|encType|enterKeyHint|fetchpriority|fetchPriority|form|formAction|formEncType|formMethod|formNoValidate|formTarget|frameBorder|headers|height|hidden|high|href|hrefLang|htmlFor|httpEquiv|id|inputMode|integrity|is|keyParams|keyType|kind|label|lang|list|loading|loop|low|marginHeight|marginWidth|max|maxLength|media|mediaGroup|method|min|minLength|multiple|muted|name|nonce|noValidate|open|optimum|pattern|placeholder|playsInline|popover|popoverTarget|popoverTargetAction|poster|preload|profile|radioGroup|readOnly|referrerPolicy|rel|required|reversed|role|rows|rowSpan|sandbox|scope|scoped|scrolling|seamless|selected|shape|size|sizes|slot|span|spellCheck|src|srcDoc|srcLang|srcSet|start|step|style|summary|tabIndex|target|title|translate|type|useMap|value|width|wmode|wrap|about|datatype|inlist|prefix|property|resource|typeof|vocab|autoCapitalize|autoCorrect|autoSave|color|incremental|fallback|inert|itemProp|itemScope|itemType|itemID|itemRef|on|option|results|security|unselectable|accentHeight|accumulate|additive|alignmentBaseline|allowReorder|alphabetic|amplitude|arabicForm|ascent|attributeName|attributeType|autoReverse|azimuth|baseFrequency|baselineShift|baseProfile|bbox|begin|bias|by|calcMode|capHeight|clip|clipPathUnits|clipPath|clipRule|colorInterpolation|colorInterpolationFilters|colorProfile|colorRendering|contentScriptType|contentStyleType|cursor|cx|cy|d|decelerate|descent|diffuseConstant|direction|display|divisor|dominantBaseline|dur|dx|dy|edgeMode|elevation|enableBackground|end|exponent|externalResourcesRequired|fill|fillOpacity|fillRule|filter|filterRes|filterUnits|floodColor|floodOpacity|focusable|fontFamily|fontSize|fontSizeAdjust|fontStretch|fontStyle|fontVariant|fontWeight|format|from|fr|fx|fy|g1|g2|glyphName|glyphOrientationHorizontal|glyphOrientationVertical|glyphRef|gradientTransform|gradientUnits|hanging|horizAdvX|horizOriginX|ideographic|imageRendering|in|in2|intercept|k|k1|k2|k3|k4|kernelMatrix|kernelUnitLength|kerning|keyPoints|keySplines|keyTimes|lengthAdjust|letterSpacing|lightingColor|limitingConeAngle|local|markerEnd|markerMid|markerStart|markerHeight|markerUnits|markerWidth|mask|maskContentUnits|maskUnits|mathematical|mode|numOctaves|offset|opacity|operator|order|orient|orientation|origin|overflow|overlinePosition|overlineThickness|panose1|paintOrder|pathLength|patternContentUnits|patternTransform|patternUnits|pointerEvents|points|pointsAtX|pointsAtY|pointsAtZ|preserveAlpha|preserveAspectRatio|primitiveUnits|r|radius|refX|refY|renderingIntent|repeatCount|repeatDur|requiredExtensions|requiredFeatures|restart|result|rotate|rx|ry|scale|seed|shapeRendering|slope|spacing|specularConstant|specularExponent|speed|spreadMethod|startOffset|stdDeviation|stemh|stemv|stitchTiles|stopColor|stopOpacity|strikethroughPosition|strikethroughThickness|string|stroke|strokeDasharray|strokeDashoffset|strokeLinecap|strokeLinejoin|strokeMiterlimit|strokeOpacity|strokeWidth|surfaceScale|systemLanguage|tableValues|targetX|targetY|textAnchor|textDecoration|textRendering|textLength|to|transform|u1|u2|underlinePosition|underlineThickness|unicode|unicodeBidi|unicodeRange|unitsPerEm|vAlphabetic|vHanging|vIdeographic|vMathematical|values|vectorEffect|version|vertAdvY|vertOriginX|vertOriginY|viewBox|viewTarget|visibility|widths|wordSpacing|writingMode|x|xHeight|x1|x2|xChannelSelector|xlinkActuate|xlinkArcrole|xlinkHref|xlinkRole|xlinkShow|xlinkTitle|xlinkType|xmlBase|xmlns|xmlnsXlink|xmlLang|xmlSpace|y|y1|y2|yChannelSelector|z|zoomAndPan|for|class|autofocus)|(([Dd][Aa][Tt][Aa]|[Aa][Rr][Ii][Aa]|x)-.*))$/, D = /* @__PURE__ */ ze(
  function(e) {
    return He.test(e) || e.charCodeAt(0) === 111 && e.charCodeAt(1) === 110 && e.charCodeAt(2) < 91;
  }
  /* Z+1 */
), Be = function() {
  const t = Array.prototype.slice.call(arguments).filter(Boolean), r = {}, n = [];
  t.forEach((i) => {
    (i ? i.split(" ") : []).forEach((a) => {
      if (a.startsWith("atm_")) {
        const [, c] = a.split("_");
        r[c] = a;
      } else
        n.push(a);
    });
  });
  const o = [];
  for (const i in r)
    Object.prototype.hasOwnProperty.call(r, i) && o.push(r[i]);
  return o.push(...n), o.join(" ");
}, J = Be, Ke = (e) => e.toUpperCase() === e, We = (e) => (t) => e.indexOf(t) === -1, ae = (e, t) => {
  const r = {};
  return Object.keys(e).filter(We(t)).forEach((n) => {
    r[n] = e[n];
  }), r;
};
function Ve(e, t, r) {
  const n = ae(t, r);
  if (!e) {
    const o = typeof D == "function" ? { default: D } : D;
    Object.keys(n).forEach((i) => {
      o.default(i) || delete n[i];
    });
  }
  return n;
}
var Xe = (e, t) => {
  if (process.env.NODE_ENV !== "production") {
    if (typeof e == "string" || // eslint-disable-next-line no-self-compare,no-restricted-globals
    typeof e == "number" && isFinite(e))
      return;
    const r = typeof e == "object" ? JSON.stringify(e) : String(e);
    console.warn(
      `An interpolation evaluated to '${r}' in the component '${t}', which is probably a mistake. You should explicitly cast or transform the value to a string.`
    );
  }
}, Je = 0;
function G(e) {
  let t = "";
  return process.env.NODE_ENV === "test" && (t += `mocked-styled-${Je++}`, e && e.__wyw_meta && e.__wyw_meta.className && (t += ` ${e.__wyw_meta.className}`)), (r) => {
    if (process.env.NODE_ENV !== "production" && process.env.NODE_ENV !== "test" && Array.isArray(r))
      throw new Error(
        'Using the "styled" tag in runtime is not supported. Make sure you have set up the Babel plugin correctly. See https://github.com/callstack/linaria#setup'
      );
    const n = (i, s) => {
      const { as: a = e, class: c = t } = i, u = r.propsAsIs === void 0 ? !(typeof a == "string" && a.indexOf("-") === -1 && !Ke(a[0])) : r.propsAsIs, f = Ve(u, i, [
        "as",
        "class"
      ]);
      f.ref = s, f.className = r.atomic ? J(r.class, f.className || c) : J(f.className || c, r.class);
      const { vars: y } = r;
      if (y) {
        const h = {};
        for (const p in y) {
          const m = y[p], v = m[0], _ = m[1] || "", l = typeof v == "function" ? v(i) : v;
          Xe(l, r.name), h[`--${p}`] = `${l}${_}`;
        }
        const d = f.style || {}, g = Object.keys(d);
        g.length > 0 && g.forEach((p) => {
          h[p] = d[p];
        }), f.style = h;
      }
      return e.__wyw_meta && e !== a ? (f.as = a, F(e, f)) : F(a, f);
    }, o = W ? W(n) : (
      // React.forwardRef won't available on older React versions and in Preact
      // Fallback to a innerRef prop in that case
      (i) => {
        const s = ae(i, ["innerRef"]);
        return n(s, i.innerRef);
      }
    );
    return o.displayName = r.name, o.__wyw_meta = {
      className: r.class || t,
      extends: e
    }, o;
  };
}
var S = process.env.NODE_ENV !== "production" ? new Proxy(G, {
  get(e, t) {
    return e(t);
  }
}) : G;
function Ge(e) {
  const t = +("0x" + (e == null ? void 0 : e.slice(1).replace(e.length < 5 ? /./g : "", "$&$&"))), r = t >> 16, n = t >> 8 & 255, o = t & 255;
  return Math.sqrt(0.299 * (r * r) + 0.587 * (n * n) + 0.114 * (o * o)) > 127.5 ? "dark" : "light";
}
const Qe = /* @__PURE__ */ S("div")({
  name: "CardContent",
  class: "CardContent_cene200",
  propsAsIs: !1
}), Ye = /* @__PURE__ */ S("div")({
  name: "Heading",
  class: "Heading_h1ag0jg5",
  propsAsIs: !1
}), Ze = /* @__PURE__ */ S("div")({
  name: "LogoContainer",
  class: "LogoContainer_lf8nb76",
  propsAsIs: !1
}), et = () => (e) => e.color, tt = () => (e) => Ge(e.color) === "light" ? "white" : "black", ce = /* @__PURE__ */ S("div")({
  name: "Card",
  class: "Card_cn7bqld",
  propsAsIs: !1,
  vars: {
    "cn7bqld-0": [et()],
    "cn7bqld-1": [tt()]
  }
}), rt = () => ce, nt = /* @__PURE__ */ S(rt())({
  name: "DefaultCard",
  class: "DefaultCard_diw1l80",
  propsAsIs: !0
}), ot = () => ce, st = /* @__PURE__ */ S(ot())({
  name: "AutohideCard",
  class: "AutohideCard_ackent1",
  propsAsIs: !0
}), B = ({ variant: e }) => e === "autohide";
const it = () => (e) => B(e) ? "initial" : "none", at = () => (e) => B(e) ? "initial" : `'${e.ctaLabel}'`, ct = /* @__PURE__ */ S("div")({
  name: "Cta",
  class: "Cta_cbylxvg",
  propsAsIs: !1,
  vars: {
    "cbylxvg-0": [it()],
    "cbylxvg-1": [at()]
  }
});
const lt = /* @__PURE__ */ S("div")({
  name: "Text",
  class: "Text_t1gpznzf",
  propsAsIs: !1
}), ut = (e) => {
  switch (e) {
    case "autohide":
      return st;
    case "default":
    default:
      return nt;
  }
}, ft = (e) => Array.isArray(e) ? e.length ? e.join(" ") : null : e ?? null, dt = ({ fallback: e, key: t, translatorFunction: r }) => {
  const n = r(t);
  return n === t ? e : n;
}, pt = ({
  color: e,
  ctaText: t,
  disabled: r,
  heading: n,
  id: o,
  label: i,
  logoAlt: s,
  logoUrl: a,
  onClick: c,
  text: u,
  variant: f
}) => {
  const y = ut(f), h = ft(i), d = qe(a), { t: g } = Se(), p = dt({ fallback: "CLAIM", key: "CX_CLAIM_OFFER_CTA", translatorFunction: g });
  return /* @__PURE__ */ C(y, { color: e, "data-height": `${n} !!`, "data-testid": "offer-card", children: /* @__PURE__ */ M(Qe, { "data-offer-id": o, children: [
    /* @__PURE__ */ M(Ze, { children: [
      /* @__PURE__ */ C("img", { alt: s, src: d }),
      h && /* @__PURE__ */ C("span", { children: h })
    ] }),
    /* @__PURE__ */ M(Ye, { children: [
      n,
      /* @__PURE__ */ C(z, {})
    ] }),
    u ? /* @__PURE__ */ C(lt, { dangerouslySetInnerHTML: { __html: u } }) : null,
    r ? null : /* @__PURE__ */ C(ct, { ctaLabel: p, variant: f, children: /* @__PURE__ */ C(
      "button",
      {
        onClick: (m) => {
          m.preventDefault(), c(m);
        },
        children: /* @__PURE__ */ C("span", { children: t })
      }
    ) })
  ] }) });
}, Q = typeof window < "u";
function ht(e, t) {
  const r = Q ? new IntersectionObserver(([n]) => {
    n.isIntersecting && (t && t(), r == null || r.disconnect());
  }) : null;
  $(() => {
    Q && e.current && r && r.observe(e.current);
  }, [e]);
}
const H = /{{([^{{}}]*)}}/g, yt = (e) => e.replace(/[ /-]+/g, "_").replace(/[^a-zA-Z0-9_]/g, "").replace(/_+/g, "_").toUpperCase(), mt = ({ marketName: e, t }) => {
  const n = `CX_MARKET_TYPE_${yt(e)}`, o = t(n, { ns: "label" });
  return o === n ? e : o;
}, gt = (e) => {
  const t = e.match(new RegExp("(?<=\\s)(at\\.|vs\\.?|@|v\\.?|at)(?=\\s)", "i"));
  if (!t)
    return null;
  const r = t[1], n = e.split(new RegExp(`\\s${r.replace(".", "\\.")}\\s`, "i")).map((o) => o.trim());
  return n.length === 2 ? { parts: n, separator: r } : null;
}, vt = (e, t, r) => typeof e != "string" ? "" : t == null || typeof t != "object" ? e : RegExp(H.source).test(e) ? e.replace(H, (n, o) => {
  const i = o.trim().split(/\./);
  let s = t;
  for (let a = 0; a < i.length; a += 1) {
    if (s[i[a]] == null)
      return n;
    s = s[i[a]];
  }
  if (typeof s == "string") {
    const { SPORT: a = "" } = t, c = a == null ? void 0 : a.toLowerCase();
    switch (i[0]) {
      case "EVENT":
        return !c || !r ? s : r(s, {
          ns: c
        });
      case "MARKET":
        return r ? mt({
          marketName: s,
          t: r
        }) : s;
      case "SPORT":
        return r ? r(V(s), {
          ns: "label"
        }) : s;
      case "SUBEVENT": {
        const u = gt(s);
        if (u) {
          const [f, y] = u.parts.map((d) => r ? r(d ? V(d) : "", {
            ns: c
          }) : d);
          return `${f} ${u.separator} ${y}`;
        }
        return s;
      }
      default:
        return s;
    }
  }
  return n;
}) : e, le = (e = "") => {
  if (typeof e != "string" || !e.trim())
    return {};
  const t = "|", r = e.split(t).map((n) => n.trim().split("=").map((o) => o.trim()));
  return Object.fromEntries(r);
}, wt = ({
  fallbackString: e = "",
  placeholdersString: t,
  subjectString: r,
  translatorFunction: n
}) => {
  const o = le(t), i = vt(r, o, n);
  return RegExp(H.source).test(i) && e || i;
}, Y = ({
  placeholders: e,
  template: t = "",
  translatorFunction: r,
  value: n = ""
}) => !t || !e ? n : n && wt({
  fallbackString: n.trim(),
  placeholdersString: e,
  subjectString: t.trim(),
  translatorFunction: r
}), bt = (e) => {
  if (!e)
    return;
  const t = le(e), r = Object.keys(t);
  return r.length ? [
    ...new Set(
      r.map((n) => {
        var o;
        switch (n) {
          case "SUBEVENT":
          case "EVENT":
            return (o = t.SPORT) == null ? void 0 : o.toLowerCase();
          case "SPORT":
          case "MARKET":
            return "label";
          default:
            return;
        }
      }).filter((n) => n !== void 0)
    )
  ] : e;
}, Ct = "application/json", ue = "Content-Type", L = Symbol(), fe = Symbol();
function Z(e = {}) {
  var t;
  const r = e instanceof Array ? Object.fromEntries(e) : e;
  return (t = Object.entries(r).find(([n]) => n.toLowerCase() === ue.toLowerCase())) === null || t === void 0 ? void 0 : t[1];
}
function ee(e) {
  return /^application\/.*json.*/.test(e);
}
const O = function(e, t, r = !1) {
  return Object.entries(t).reduce((n, [o, i]) => {
    const s = e[o];
    return Array.isArray(s) && Array.isArray(i) ? n[o] = r ? [...s, ...i] : i : typeof s == "object" && typeof i == "object" ? n[o] = O(s, i, r) : n[o] = i, n;
  }, { ...e });
}, R = {
  // Default options
  options: {},
  // Error type
  errorType: "text",
  // Polyfills
  polyfills: {
    // fetch: null,
    // FormData: null,
    // URL: null,
    // URLSearchParams: null,
    // performance: null,
    // PerformanceObserver: null,
    // AbortController: null,
  },
  polyfill(e, t = !0, r = !1, ...n) {
    const o = this.polyfills[e] || (typeof self < "u" ? self[e] : null) || (typeof global < "u" ? global[e] : null);
    if (t && !o)
      throw new Error(e + " is not defined");
    return r && o ? new o(...n) : o;
  }
};
function _t(e, t = !1) {
  R.options = t ? e : O(R.options, e);
}
function Et(e, t = !1) {
  R.polyfills = t ? e : O(R.polyfills, e);
}
function xt(e) {
  R.errorType = e;
}
const kt = (e) => (t) => e.reduceRight((r, n) => n(r), t) || t;
class de extends Error {
}
const Tt = (e) => {
  const t = /* @__PURE__ */ Object.create(null);
  e = e._addons.reduce((l, w) => w.beforeRequest && w.beforeRequest(l, e._options, t) || l, e);
  const { _url: r, _options: n, _config: o, _catchers: i, _resolvers: s, _middlewares: a, _addons: c } = e, u = new Map(i), f = O(o.options, n);
  let y = r;
  const h = kt(a)((l, w) => (y = l, o.polyfill("fetch")(l, w)))(r, f), d = new Error(), g = h.catch((l) => {
    throw { [L]: l };
  }).then((l) => {
    var w;
    if (!l.ok) {
      const b = new de();
      if (b.cause = d, b.stack = b.stack + `
CAUSE: ` + d.stack, b.response = l, b.status = l.status, b.url = y, l.type === "opaque")
        throw b;
      const E = o.errorType === "json" || ((w = l.headers.get("Content-Type")) === null || w === void 0 ? void 0 : w.split(";")[0]) === "application/json";
      return (o.errorType ? E ? l.text() : l[o.errorType]() : Promise.resolve(l.body)).then((x) => {
        throw b.message = typeof x == "string" ? x : l.statusText, x && (E && typeof x == "string" ? (b.text = x, b.json = JSON.parse(x)) : b[o.errorType] = x), b;
      });
    }
    return l;
  }), p = (l) => l.catch((w) => {
    const b = Object.prototype.hasOwnProperty.call(w, L), E = b ? w[L] : w, P = (E == null ? void 0 : E.status) && u.get(E.status) || u.get(E == null ? void 0 : E.name) || b && u.has(L) && u.get(L);
    if (P)
      return P(E, e);
    const x = u.get(fe);
    if (x)
      return x(E, e);
    throw E;
  }), m = (l) => (w) => /* If a callback is provided, then callback with the body result otherwise return the parsed body itself. */ p(l ? g.then((b) => b && b[l]()).then((b) => w ? w(b) : b) : g.then((b) => w ? w(b) : b)), v = {
    _wretchReq: e,
    _fetchReq: h,
    _sharedState: t,
    res: m(null),
    json: m("json"),
    blob: m("blob"),
    formData: m("formData"),
    arrayBuffer: m("arrayBuffer"),
    text: m("text"),
    error(l, w) {
      return u.set(l, w), this;
    },
    badRequest(l) {
      return this.error(400, l);
    },
    unauthorized(l) {
      return this.error(401, l);
    },
    forbidden(l) {
      return this.error(403, l);
    },
    notFound(l) {
      return this.error(404, l);
    },
    timeout(l) {
      return this.error(408, l);
    },
    internalError(l) {
      return this.error(500, l);
    },
    fetchError(l) {
      return this.error(L, l);
    }
  }, _ = c.reduce((l, w) => ({
    ...l,
    ...typeof w.resolver == "function" ? w.resolver(l) : w.resolver
  }), v);
  return s.reduce((l, w) => w(l, e), _);
}, At = {
  _url: "",
  _options: {},
  _config: R,
  _catchers: /* @__PURE__ */ new Map(),
  _resolvers: [],
  _deferred: [],
  _middlewares: [],
  _addons: [],
  addon(e) {
    return { ...this, _addons: [...this._addons, e], ...e.wretch };
  },
  errorType(e) {
    return {
      ...this,
      _config: {
        ...this._config,
        errorType: e
      }
    };
  },
  polyfills(e, t = !1) {
    return {
      ...this,
      _config: {
        ...this._config,
        polyfills: t ? e : O(this._config.polyfills, e)
      }
    };
  },
  url(e, t = !1) {
    if (t)
      return { ...this, _url: e };
    const r = this._url.split("?");
    return {
      ...this,
      _url: r.length > 1 ? r[0] + e + "?" + r[1] : this._url + e
    };
  },
  options(e, t = !1) {
    return { ...this, _options: t ? e : O(this._options, e) };
  },
  headers(e) {
    const t = e ? Array.isArray(e) ? Object.fromEntries(e) : "entries" in e ? Object.fromEntries(e.entries()) : e : {};
    return { ...this, _options: O(this._options, { headers: t }) };
  },
  accept(e) {
    return this.headers({ Accept: e });
  },
  content(e) {
    return this.headers({ [ue]: e });
  },
  auth(e) {
    return this.headers({ Authorization: e });
  },
  catcher(e, t) {
    const r = new Map(this._catchers);
    return r.set(e, t), { ...this, _catchers: r };
  },
  catcherFallback(e) {
    return this.catcher(fe, e);
  },
  // eslint-disable-next-line @typescript-eslint/no-unused-vars
  resolve(e, t = !1) {
    return { ...this, _resolvers: t ? [e] : [...this._resolvers, e] };
  },
  defer(e, t = !1) {
    return {
      ...this,
      _deferred: t ? [e] : [...this._deferred, e]
    };
  },
  middlewares(e, t = !1) {
    return {
      ...this,
      _middlewares: t ? e : [...this._middlewares, ...e]
    };
  },
  fetch(e = this._options.method, t = "", r = null) {
    let n = this.url(t).options({ method: e });
    const o = Z(n._options.headers), i = this._config.polyfill("FormData", !1), s = typeof r == "object" && !(i && r instanceof i) && (!n._options.headers || !o || ee(o));
    return n = r ? s ? n.json(r, o) : n.body(r) : n, Tt(n._deferred.reduce((a, c) => c(a, a._url, a._options), n));
  },
  get(e = "") {
    return this.fetch("GET", e);
  },
  delete(e = "") {
    return this.fetch("DELETE", e);
  },
  put(e, t = "") {
    return this.fetch("PUT", t, e);
  },
  post(e, t = "") {
    return this.fetch("POST", t, e);
  },
  patch(e, t = "") {
    return this.fetch("PATCH", t, e);
  },
  head(e = "") {
    return this.fetch("HEAD", e);
  },
  opts(e = "") {
    return this.fetch("OPTIONS", e);
  },
  body(e) {
    return { ...this, _options: { ...this._options, body: e } };
  },
  json(e, t) {
    const r = Z(this._options.headers);
    return this.content(t || ee(r) && r || Ct).body(JSON.stringify(e));
  }
};
function A(e = "", t = {}) {
  return { ...At, _url: e, _options: t };
}
A.default = A;
A.options = _t;
A.errorType = xt;
A.polyfills = Et;
A.WretchError = de;
class St extends Error {
  constructor(r, n, o, i, s) {
    super(r);
    T(this, "statusCode");
    T(this, "endpoint");
    T(this, "args");
    T(this, "response");
    this.name = "ApiError", this.statusCode = n, this.endpoint = o, this.args = i, this.response = s;
  }
}
class K extends St {
  constructor(t, r, n, o) {
    super(`Client error ${t} occurred while fetching ${r}`, t, r, n, o), this.name = "Api4xxError";
  }
}
class Ot extends K {
  constructor(t, r, n) {
    super(404, t, r, n), this.name = "Api404Error";
  }
}
class Lt extends K {
  constructor(t, r, n) {
    super(400, t, r, n), this.name = "Api400Error";
  }
}
class Rt {
  constructor(t = {}) {
    T(this, "logger");
    T(this, "notFoundLogLevel");
    T(this, "badRequestLogLevel");
    T(this, "other4xxLogLevel");
    this.logger = t.logger, this.notFoundLogLevel = t.notFoundLogLevel || "info", this.badRequestLogLevel = t.badRequestLogLevel || "warn", this.other4xxLogLevel = t.other4xxLogLevel || "warn";
  }
  log(t, r, n) {
    this.logger && this.logger[t](r, n);
  }
  async handleApiError(t, r, n) {
    if (!(t instanceof Response))
      throw t;
    const { status: o } = t;
    if (o === 404) {
      const i = new Ot(r, n, t);
      return this.log(this.notFoundLogLevel, i.message, {
        args: n,
        endpoint: r,
        statusCode: o
      }), null;
    }
    if (o === 400) {
      const i = new Lt(r, n, t);
      return this.log(this.badRequestLogLevel, i.message, {
        args: n,
        endpoint: r,
        statusCode: o
      }), null;
    }
    if (o >= 400 && o < 500) {
      const i = new K(o, r, n, t);
      return this.log(this.other4xxLogLevel, i.message, {
        args: n,
        endpoint: r,
        statusCode: o
      }), null;
    }
    throw t;
  }
}
const Pt = (e, t) => {
  const r = new Rt(t);
  return e.catcher(404, async (n) => (await r.handleApiError(n.response, n.url), null)).catcher(400, async (n) => (await r.handleApiError(n.response, n.url), null)).catcher(401, async (n) => (await r.handleApiError(n.response, n.url), null)).catcher(403, async (n) => (await r.handleApiError(n.response, n.url), null)).catcherFallback(async (n) => {
    if (n.status >= 400 && n.status < 500)
      return await r.handleApiError(n.response, n.url), null;
    throw n;
  });
}, jt = (e) => e ? e.split(",").map((t) => t.trim()).filter(Boolean).join(",") : "", It = (e) => {
  const t = Object.entries(e).filter(([, r]) => r !== void 0).sort(([r], [n]) => r.localeCompare(n)).map(([r, n]) => [r, String(n)]);
  return new URLSearchParams(t).toString();
}, Mt = async (e, t, r) => {
  var p;
  const { apiKey: n, countryCode: o, deviceType: i, offerIds: s, offerLimit: a, sortBy: c, subdivisionCode: u, vcId: f } = t;
  if (!n)
    throw (p = r == null ? void 0 : r.logger) == null || p.error("No apiKey provided"), new Error("No apiKey provided.");
  const y = f ? { variationContainerId: f } : s ? { offerIds: jt(s) } : void 0, h = It({
    ...y,
    ...i && { deviceType: i },
    ...a ? { limit: a } : {},
    ...c ? { sort: c } : {}
  }), d = new URL(`${e}/v1/offers?${h}`);
  return Pt(
    A(d.toString(), {
      headers: {
        accept: "application/json",
        "api-key": n,
        "content-type": "application/json",
        ...o && { "country-code": o },
        ...u && { "subdivision-code": u },
        ...(r == null ? void 0 : r.nocache) && { "Cache-Control": "no-cache" }
      }
    }),
    r
  ).get().json();
}, pe = async (e = "https://offers-delivery-api-stg.core.occloud.io", t, r = {}) => {
  try {
    return await Mt(e, t, r);
  } catch (n) {
    throw r.logger && r.logger.error(n), n;
  }
}, he = ({
  apiKey: e,
  countryCode: t,
  offerIds: r,
  offerLimit: n,
  sortBy: o,
  subdivisionCode: i,
  vcId: s
}) => ["offers-slim", e, r, s, t, i, n, o], Dt = (e) => e && e.map((t) => {
  var r, n;
  return "code" in t.bookmaker && typeof t.bookmaker.code == "string" && (t.bookmaker.feedsCode = t.bookmaker.code, delete t.bookmaker.code), "clickoutUrl" in t && typeof ((r = t.clickoutUrl) == null ? void 0 : r.url) == "string" && (t.clickOutUrl = (n = t.clickoutUrl) == null ? void 0 : n.url, delete t.clickoutUrl), "isTermsExpanded" in t && typeof t.isTermsExpanded == "boolean" && (t.autoExpandedTermsAndConditions = t.isTermsExpanded, delete t.isTermsExpanded), t;
}), Ut = ({
  dataApiEndpoint: e,
  ...t
}) => Ce({
  queryFn: () => pe(e, t, {
    logger: console
  }),
  queryKey: he(t),
  select: (r) => Dt(r)
}), Nt = (e, t, r) => {
  e.push({
    action: "offers_clickout",
    bookieCode: t.bookie,
    category: "Widget",
    event: "offer_clickouts",
    label: "claim_offer",
    offerIndex: r + 1,
    offerName: t.heading,
    page: window.location.href,
    variation: "horizontal-slim"
  });
}, $t = (e, t) => {
  e.push({
    action: "impression",
    category: "Widget",
    event: "widget_impression",
    label: "widget_impression",
    page: window.location.href,
    variation: "horizontal-slim",
    widgetType: "offers",
    ...t ?? {}
  });
}, Ft = ({
  bookmaker: e,
  bookmakerCode: t,
  clickOutUrl: r,
  clickoutUrl: n,
  displayTitle: o,
  displayTitleTemplate: i,
  featuredLabels: s,
  fullTerms: a,
  id: c,
  offerCta: u,
  offerCtaTemplate: f,
  shortTerms: y
}, { placeholders: h, translation: d, variant: g }) => {
  var l;
  const p = r || (n == null ? void 0 : n.url), m = Y({
    placeholders: h,
    template: f,
    translatorFunction: d,
    value: u
  }), v = Y({
    placeholders: h,
    template: i,
    translatorFunction: d,
    value: o
  }), _ = B({ variant: g }) && !m || !p;
  return {
    bookie: t,
    color: e.primaryColor,
    ctaText: m,
    disabled: _,
    heading: v,
    id: c,
    label: s ?? void 0,
    logoAlt: e.name || t,
    logoUrl: (l = e.logoFull) == null ? void 0 : l.url,
    text: g === "autohide" ? a : y ? `<p>${y}</p>` : void 0,
    url: p,
    variant: g ?? "default"
  };
}, qt = (e, t) => (e || []).map((r) => Ft(r, t));
const zt = /* @__PURE__ */ S("div")({
  name: "Theme",
  class: "Theme_t4ho7n3",
  propsAsIs: !1
}), Ht = () => typeof window < "u" ? window.dataLayer : [], Bt = (e) => {
  const {
    analyticsDataLayer: t = Ht(),
    analyticsImpressionEventData: r,
    apiKey: n,
    clickoutService: o = "OFFERS_CLICKOUT_SERVICE",
    clickoutServiceUrl: i,
    deviceType: s = "desktop",
    disableAnalytics: a,
    fullPageUrl: c,
    gtmId: u = null,
    pageUrl: f,
    placeholders: y,
    recommendedMarketId: h,
    uncappedOfferDisplay: d,
    variant: g
  } = e, { data: p } = Ut(e), m = Array.isArray(p) && p.length > 0, v = g || "default", l = Pe({
    apiKey: n,
    clickoutOrigin: "offers-slim",
    clickoutServiceUrl: i,
    deviceType: s,
    fullPageUrl: c,
    gtmId: u,
    offers: p,
    pageUrl: f,
    recommendedMarketId: h,
    shouldUseClickoutService: o === "OFFERS_CLICKOUT_SERVICE"
  }), w = bt(y), { t: b } = ie(w ?? ["label", "football"]), E = U(null);
  ht(E, () => {
    a || $t(t, r || {});
  });
  const P = (x, j) => {
    a || Nt(t, j, x), window.open(j.url, "_blank", "noopener noreferrer");
  };
  return /* @__PURE__ */ C(zt, { "data-testid": "offers-slim", ref: E, children: m && /* @__PURE__ */ C(Fe, { uncappedOfferDisplay: d, variant: v, children: qt(l, {
    placeholders: y,
    translation: b,
    variant: v
  }).map((x, j) => /* @__PURE__ */ F(pt, { ...x, key: j, onClick: () => P(j, x), variant: v })) }) });
};
var Kt = typeof k == "object" && k && k.Object === Object && k, Wt = typeof self == "object" && self && self.Object === Object && self, Vt = Kt || Wt || Function("return this")(), te = Vt.Symbol, re = te ? te.prototype : void 0;
re && re.toString;
var Xt = typeof k == "object" && k && k.Object === Object && k, Jt = typeof self == "object" && self && self.Object === Object && self, Gt = Xt || Jt || Function("return this")(), ne = Gt.Symbol, oe = ne ? ne.prototype : void 0;
oe && oe.toString;
(function(e) {
  typeof globalThis != "object" && (this ? t() : (e.defineProperty(e.prototype, "_T_", {
    configurable: !0,
    get: t
  }), _T_));
  function t() {
    var r = this || self;
    r.globalThis = r, delete e.prototype._T_;
  }
})(Object);
const Qt = (e, t) => t.skipDedupe || t.method !== "GET", Yt = (e, t) => t.method + "@" + e, Zt = (e) => e.clone(), ye = ({ skip: e = Qt, key: t = Yt, resolver: r = Zt } = {}) => {
  const n = /* @__PURE__ */ new Map();
  return (o) => (i, s) => {
    if (e(i, s))
      return o(i, s);
    const a = t(i, s);
    if (!n.has(a))
      n.set(a, []);
    else
      return new Promise((c, u) => {
        n.get(a).push([c, u]);
      });
    try {
      return o(i, s).then((c) => (n.get(a).forEach(([u]) => u(r(c))), n.delete(a), c)).catch((c) => {
        throw n.get(a).forEach(([, u]) => u(c)), n.delete(a), c;
      });
    } catch (c) {
      return n.delete(a), Promise.reject(c);
    }
  };
}, er = (e, t) => t.skipCache || t.method !== "GET", tr = (e, t) => t.method + "@" + e, rr = () => !1, nr = () => null, or = (e) => e.ok, sr = ({ throttle: e = 1e3, skip: t = er, key: r = tr, clear: n = rr, invalidate: o = nr, condition: i = or, flagResponseOnCacheHit: s = "__cached" } = {}) => {
  const a = /* @__PURE__ */ new Map(), c = /* @__PURE__ */ new Map(), u = /* @__PURE__ */ new Set(), f = (h) => {
    e && !u.has(h) && (u.add(h), setTimeout(() => {
      u.delete(h);
    }, e));
  }, y = (h) => (d, g) => {
    const p = r(d, g);
    let m = o(d, g);
    if (m && (m instanceof Array || (m = [m]), m.forEach((v) => {
      typeof v == "string" ? a.delete(v) : v instanceof RegExp && a.forEach((_, l) => {
        v.test(l) && a.delete(l);
      });
    })), n(d, g) && a.clear(), t(d, g))
      return h(d, g);
    if (u.has(p)) {
      if (a.has(p)) {
        const v = a.get(p).clone();
        return s && Object.defineProperty(v, s, {
          value: p,
          enumerable: !1
        }), Promise.resolve(v);
      } else if (c.has(p))
        return new Promise((v, _) => {
          c.get(p).push([v, _]);
        });
    }
    return c.has(p) || c.set(p, []), f(p), h(d, g).then((v) => (i(v.clone()) && a.set(p, v.clone()), c.get(p).forEach(([_]) => _(v.clone())), c.delete(p), v)).catch((v) => {
      throw c.get(p).forEach(([, _]) => _(v)), c.delete(p), v;
    });
  };
  return y.cacheResponse = function(h, d) {
    f(h), a.set(h, d);
  }, y.cache = a, y.inflight = c, y.throttling = u, y;
}, ir = (e, t) => e * t, ar = (e) => e && e.ok, me = ({ delayTimer: e = 500, delayRamp: t = ir, maxAttempts: r = 10, until: n = ar, onRetry: o = null, retryOnNetworkError: i = !1, resolveWithLatestResponse: s = !1, skip: a } = {}) => (c) => (u, f) => {
  let y = 0;
  if (a && a(u, f))
    return c(u, f);
  const h = (d, g) => Promise.resolve(n(d, g)).then((p) => p ? d && s ? d : g ? Promise.reject(g) : d : (y++, !r || y <= r ? new Promise((m) => {
    const v = t(e, y);
    setTimeout(() => {
      typeof o == "function" ? Promise.resolve(o({
        response: d,
        error: g,
        url: u,
        options: f
      })).then((_ = {}) => {
        var l, w;
        m(c((l = _ && _.url) !== null && l !== void 0 ? l : u, (w = _ && _.options) !== null && w !== void 0 ? w : f));
      }) : m(c(u, f));
    }, v);
  }).then(h).catch((m) => {
    if (!i)
      throw m;
    return h(null, m);
  }) : d && s ? d : Promise.reject(g || new Error("Number of attempts exceeded."))));
  return c(u, f).then(h).catch((d) => {
    if (!i)
      throw d;
    return h(null, d);
  });
};
A().middlewares([
  ye(),
  me({
    delayRamp: (e, t) => e * t,
    delayTimer: 100,
    maxAttempts: 3,
    resolveWithLatestResponse: !1
  }),
  sr({
    key: (e, t) => t.headers["X-Cache-Key"],
    throttle: 1e3 * 60 * 60 * 24 * 7
    // 7 days (max safe is ~24.8 days)
  })
]);
A().middlewares([
  ye(),
  me({
    delayRamp: (e, t) => e * t,
    delayTimer: 100,
    maxAttempts: 3,
    resolveWithLatestResponse: !1
  })
]);
function cr(e = {}) {
  return new be.QueryClient({
    defaultOptions: {
      queries: {
        retry: 3,
        retryDelay(t) {
          return t * 100;
        }
      }
    },
    ...e
  });
}
const mr = async (e, t) => {
  const r = cr();
  try {
    await r.prefetchQuery({
      queryFn: () => pe(t, e, { nocache: e.nocache }),
      queryKey: he(e)
    });
  } catch {
  }
  return {
    dehydratedState: _e(r)
  };
}, lr = (e) => new ke({
  defaultOptions: {
    queries: {
      gcTime: e ? 0 : void 0,
      refetchOnMount: !!e,
      staleTime: e ? 0 : 1 / 0
    }
  }
});
function gr({ dehydratedState: e, loadingSlot: t, nocache: r, ...n }) {
  const [o] = N(() => {
    const i = lr(r);
    return Ee(i, e), i;
  });
  return /* @__PURE__ */ C(xe, { client: o, children: /* @__PURE__ */ C(Ae, { i18nInstance: n.i18n, children: /* @__PURE__ */ C(we, { fallback: t ?? /* @__PURE__ */ C("div", { children: "Loading..." }), children: /* @__PURE__ */ C(Bt, { ...n }) }) }) });
}
export {
  gr as default,
  mr as loadDataForServer
};
//# sourceMappingURL=index.es.js.map
